const entryCollectionSync = require('./contentful/entry-collection-sync');
// const entryUnpublish = require('./contentful/entry-unpublish');
const entryPublish = require('./contentful/entry-publish');
const getEntryCollection = require('./contentful/entry-collection-get');
const getSpace = require('./contentful/get-space');
const transformer = require('./transformers/block');
// const processError = require('./contentful/error-process');

const saveCollection = (space, blocks, forcePublish = true) => {
  // Transform the blocks and filter out any invalid null blocks
  const data = blocks.map(transformer.internalToContentful).filter((b) => b !== null);

  return entryCollectionSync(space, data, forcePublish).then((entries) => {
    return entries.map(transformer.contentfulToInternal);
  });
};

module.exports = {
  saveBlockArray(currentBodytextLinks, newBlocks, forcePublish) {
    // const currentBlockIds = currentBodytextLinks.map((block) => block.sys.id);

    return getSpace().then((space) => {
      return saveCollection(space, newBlocks, forcePublish).then((blocks) => {
        return blocks;

        // Do not archive unused blocks, as they might be used in a publised entry.

        // const blockIds = blocks.map((block) => block.id);
        // const unusedBlockIds = currentBlockIds.filter((id) => {
        //   return blockIds.indexOf(id) === -1;
        // });

        // if (unusedBlockIds.length === 0) {
        //   return blocks;
        // }

        // return getEntryCollection(space, unusedBlockIds).then((response) => {
        //   // Archive all content blocks that are no longer needed in the
        //   // description:
        //   return Promise.all(response.items.map((entry) => {
        //     // First unpublish, as published entries cannot be archived:
        //     return entryUnpublish(entry).then((entry) => {
        //       // Then archive:
        //       return entry.archive().catch(
        //         processError
        //       );
        //     });
        //   }));
        // }).then(() => {
        //   return blocks;
        // });
      });
    });
  },

  publishBlocks(ids) {
    return getSpace().then((space) => {
      return getEntryCollection(space, ids).then((response) => {
        return Promise.all(response.items.map(entryPublish));
      });
    });
  }
};

